import React from 'react';
import {bindActionCreators} from "redux";

//import {fetchUserAlbums, resetUserAlbums} from "../../../creators/user.albums";
import {fetchUserAlbum, resetUserAlbum} from "../../../creators/user.album";
import {createAlbumMedia} from "../../../creators/album.media";

import Icon from "../Icon";
import MediaDatas from "./components/MediaDatas";
import AlbumInformations from "../AlbumInformations";
import connect from "react-redux/es/connect/connect";
import {Button} from "../Button";
import Modal from "../Modal";
import UploadMultipleGallery from "./UploadMultipleGallery";
import {fetchTagsMedia} from "../../../creators/tagsMedia";
import history from "../../../libs/history";
import createLink from "../../../libs/createLink";
import {fetchCurrentUserAlbums, resetCurrentUserAlbums} from "../../../creators/currentUser.albums";


class Uploads extends React.Component {
    constructor(props) {
        super(props);

        this.title = process.env.REACT_APP_PUBLIC_URL === "https://voissa.dev" ? "Titre auto preprod" : "";

        this.initialImage = {
            kind: "",
            title: this.title,
            contentRaw: {},
            tags: [],
            contentReview: 0,
            fileName: {},
            preview: "",
        };
        this.initialAlbum = {
            title: '',
            description: '',
            right: "public",
            error: false,
            type: "gallery",
            comment: {
                allowed: true,
                toValidate: false
            }
        };
        this.state = {
            toggleMediaInformations: true,
            toggleAlbumInformations: false,
            currentMedia: this.initialImage,
            currentMediaIndex: -1,
            uploadedMedias: [],
            toggleUploadMedia: "",
            currentAlbumId: this.props.currentAlbumId || 0,
            currentAlbumSlug: "",
            albumError: false,

            multipleRawFiles: [],
            currentUpload : 0
        };
        this.handleAlbum = this.handleAlbum.bind(this);
        this.handleTags = this.handleTags.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.getUploadData = this.getUploadData.bind(this);
        this.handleCurrentMediaDatas = this.handleCurrentMediaDatas.bind(this);
        this.handleCurrentMediaSelection = this.handleCurrentMediaSelection.bind(this);
        this.handleDeleteSelectedMedia = this.handleDeleteSelectedMedia.bind(this);
        this.handleFiles = this.handleFiles.bind(this);
        this._handleCloseAlbumInformations = this._handleCloseAlbumInformations.bind(this);

        //if(this.props.albumsTotal === 0){
            this.props.fetchCurrentUserAlbums(this.props.currentUserId, {limit : false});
        //}
        this.props.fetchTagsMedia({});
        //this.props.resetUserAlbum();
    }

    componentDidMount() {
        if(this.props.albums.length >= 1){
            this.setState({currentAlbumId: this.props.albums[0]._id});
        }
    }

    componentDidUpdate(prevProps) {
        if((prevProps.albumsTotal !== this.props.albumsTotal) || (prevProps.albums !== this.props.albums)){
            let currentAlbumId = this.props.albums.length >= 1 ? this.props.albums[0]._id : 0;
            this.setState({currentAlbumId, toggleAlbumInformations : this.props.albumsTotal === 0});
        }
    }

    handleAlbum(albumId) {
        this.setState({currentAlbumId: albumId});
    }

    handleCurrentMediaDatas(name, value) {
        let uploadedMedias = this.state.uploadedMedias;
        uploadedMedias[this.state.currentMediaIndex] = {...uploadedMedias[this.state.currentMediaIndex], [name]: value};
        let currentMedia = {...this.state.currentMedia};
        let newCurrentMedia = {...currentMedia, [name]: value};
        this.setState({currentMedia: newCurrentMedia, uploadedMedias});
    }

    handleTags(name, newTags) {
        let uploadedMedias = this.state.uploadedMedias;
        uploadedMedias[this.state.currentMediaIndex] = {...uploadedMedias[this.state.currentMediaIndex], [name]: newTags};
        let currentMedia = this.state.currentMedia;
        let newCurrentMedia = {...currentMedia, [name]: newTags};
        this.setState({currentMedia: newCurrentMedia, uploadedMedias});
    }

    getUploadData(data, preview){
        let kind = data.type === "video" ? "video" : "gallery";
        let currentMedia = {...this.initialImage, kind, preview: data.preview, tmpId : data._id, title : this.title};
        let uploadedMedias = [...this.state.uploadedMedias];
        uploadedMedias.push({
            ...this.initialImage,
            kind,
            preview: data.preview,
            tmpId : data._id,
            title : this.title
        });
        this.setState({currentMedia, uploadedMedias, preview : data.preview, currentMediaIndex: this.state.uploadedMedias.length, currentUpload : this.state.currentUpload - 1});
    }

    handleCurrentMediaSelection(index){
        let currentMedia = this.state.uploadedMedias[index];
        this.setState({currentMedia, currentMediaIndex: index});
    }

    handleDeleteSelectedMedia(index){
        let uploadedMedias = this.state.uploadedMedias;
        uploadedMedias.splice(index, 1);
        let currentMediaIndex = uploadedMedias.length >= 1 ? 0 : -1;
        let currentMedia = uploadedMedias.length >= 1 ? this.state.uploadedMedias[0] : this.initialImage;
        this.setState({uploadedMedias, currentMedia, currentMediaIndex});
    }

    handleFiles(){
        let multipleRawFiles = this.state.multipleRawFiles;
        let newFiles = document.getElementById('multipleUploadInput').files;
        newFiles = Object.values(newFiles);
        let currentUpload = this.state.currentUpload + newFiles.length;
        multipleRawFiles = [...multipleRawFiles, ...newFiles];
        this.setState({multipleRawFiles, currentUpload}, ()=>document.getElementById("multipleUploadInput").value = "");
    }

    _handleCloseAlbumInformations(){
        this.setState({toggleAlbumInformations: false});
        if (!this.props.albumsTotal) this.props.handleClose();
    }

    handleSubmit() {
        let uploadedMedias = this.state.uploadedMedias;
        let numberOfInvalideElement = 0;
        uploadedMedias.forEach((item,index) => {
            if(!item.title){
                if(numberOfInvalideElement === 0){
                    this.handleCurrentMediaSelection(index);
                }
                numberOfInvalideElement++;
            }
        });

        if(this.state.currentAlbumId !== 0 && numberOfInvalideElement === 0){
            uploadedMedias.map(item => {
                delete item.preview;
                return item;
            });
            let album = this.props.albums.filter(album => album._id === this.state.currentAlbumId);
            this.props.createAlbumMedia(this.state.currentAlbumId, {medias : uploadedMedias});
            history.push(createLink('userMeAlbum', {
                ...this.props.currentUserId, album : {_id: this.state.currentAlbumId, slug: album[0].slug}
            }));
            this.props.handleClose();
        } else {
            this.setState({albumError: true});
        }
    }

    render() {
        return (
            <div id={"uploads"} className={"modal-container"}>
                <div className={"upload-container"}>
                    <div className={"modal-topline"}>
                        <div className={"select-edit-album"}>
                            <select value={this.state.currentAlbumId}
                                    onChange={(event) => this.handleAlbum(event.target.value)}>
                                <option disabled={true} value="0">Choisir un album pour vos photos</option>
                                {this.props.albums.map(item =>
                                    <option value={item._id} key={item._id}>{item.title}</option>
                                )}
                            </select>
                            <span onClick={() => this.setState({toggleAlbumInformations: true})}><Icon
                                type={"plus"}/> créer un album</span>
                        </div>
                        <span className={"close-wrapper"} onClick={() => this.props.handleClose()}><Icon
                            type={"close"}/></span>
                    </div>
                    <div className={"media-list"}>
                        <input type="file"
                               id="multipleUploadInput"
                               accept="image/jpeg, image/png, image/gif, video/mp4, video/flv, video/mpeg, video/mkv, video/mov, video/qt, video/quicktime, video/wmv, video/avi"
                               style={{display: 'none'}}
                               multiple
                               onChange={()=>this.handleFiles(this.files)} />

                        <label htmlFor={"multipleUploadInput"} className={"media-block upload"}
                             onClick={()=>this.setState({toggleUploadMedia: true})}>
                            <Icon type={"plus"}/>
                        </label>

                        {this.state.multipleRawFiles.map((item, index) => (
                            <UploadMultipleGallery uploadPath={"/medias/upload"}
                                                   getUploadData={this.getUploadData}
                                                   multFileData={item}
                                                   index={index}
                                                   key={index} />
                        ))}

                        {this.state.uploadedMedias.map((item, index) => (
                            <div className={`media-block ${(item.title && item.title.length === 0)  ? 'error' : ''} 
                                            ${this.state.currentMediaIndex === index ? 'active' : ''}`}
                                 key={index}>
                                <div className={"white-borders"}
                                     onClick={()=>this.handleCurrentMediaSelection(index)}
                                     style={{backgroundImage: `url(${item.preview ? `${item.preview}?width=200` : ""})`}} />
                                            {(item.title && item.title.length === 0) && (
                                                <div className={"missing-informations"}>!</div>
                                            )}
                                <span className={"close-button"} onClick={()=>this.handleDeleteSelectedMedia(index)}><Icon type={"close"}/></span>
                                {item.kind === "video" && <div className={"video-play-button"}><Icon type={"play"}/></div>}
                            </div>
                        ))}
                    </div>
                    {this.state.uploadedMedias.length >= 1 && this.state.currentMediaIndex !== -1 && (
                        <MediaDatas
                            tagsMedia={this.props.tagsMedia}
                            toggleMediaInformations={this.state.toggleMediaInformations}
                            currentMediaIndex={this.state.currentMediaIndex}
                            currentMedia={this.state.currentMedia}
                            handleCurrentMedia={this.handleCurrentMediaDatas}
                            handleIndex={this.handleIndex}
                            handleTags={this.handleTags}
                            isUpload={true}
                        />
                    )}
                    <div className={"modal-baseline"}>
                        {this.state.albumError && (
                            <p className={"warning"}>{this.state.currentAlbumId === "" ? "Vous devez choisir un album" : "Vous devez completer les informations sur les medias en rouge"}</p>
                        )}
                        {/*{this.state.currentUpload >0 && (*/}
                        {/*    <p className={"warning"}>Il y a encore {this.state.currentUpload} media(s) en cours d'upload</p>*/}
                        {/*)}*/}
                        {/*{this.state.uploadedMedias.length >= 1 && (*/}
                        {/*    <Button btnStyle={"grey"}*/}
                        {/*            size={"small"}*/}
                        {/*            onClick={()=>this.setState({toggleMediaInformations : !this.state.toggleMediaInformations})}*/}
                        {/*            content={this.state.toggleMediaInformations ? "Voir moins" : "Voir plus"} />*/}
                        {/*)}*/}
                        <Button btnStyle={"grey"}
                                size={"small"}
                                content={"Fermer"}
                                onClick={()=>this.props.handleClose()} />
                        <Button btnStyle={"primary-reverse"}
                                size={"small"}
                                content={this.state.currentUpload === 0 ? "Enregistrer" : `Il y a encore ${this.state.currentUpload} media(s) en cours d'upload`}
                                onClick={()=>this.state.currentUpload === 0 ? this.handleSubmit() : null} />
                    </div>
                </div>
                <Modal toggle={this.state.toggleAlbumInformations}
                       handleClose={this._handleCloseAlbumInformations}>
                    <AlbumInformations
                        createAlbum={true}
                        handleClose={() => this.setState({toggleAlbumInformations: false})}
                    />
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        albums: state.currentUserAlbums.data,
        albumsTotal: state.currentUserAlbums.total,

        album: state.userAlbum.data,
        albumLoading: state.userAlbum.loading,

        currentUserId: state.currentUser.data && state.currentUser.data._id,

        tagsMedia: state.tagsMedia.data,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createAlbumMedia,

    fetchCurrentUserAlbums,
    resetCurrentUserAlbums,

    fetchUserAlbum,
    resetUserAlbum,

    fetchTagsMedia,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Uploads);